export const OrientationType = (t) => ({
  HORIZONTAL: t('horizontal'),
  VERTICAL: t('vertical'),
});

export const Color = {
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
};
